import InlineToastMessage from "th/inlineToastMessage";

export { InlineToastMessage };

customElements.define(
  "th-inline-toast-message",
  InlineToastMessage.CustomElementConstructor
);
